import { useState } from 'react';

export default function EmailSignup() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus('loading');
    setErrorMsg('');
    const body = new URLSearchParams();
    body.append('email', email.trim());
    body.append('source', 'formulario-inline');
    body.append('timestamp', new Date().toISOString());
    body.append('page', 'remesasve.com');
    try {
      const res = await fetch('https://readdy.ai/api/form/d7233ruuimmp87kg1s9g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
        setErrorMsg('Hubo un error. Por favor intenta de nuevo.');
      }
    } catch {
      setStatus('error');
      setErrorMsg('Sin conexión. Por favor intenta de nuevo.');
    }
  };

  return (
    <section id="suscribir" className="py-16 bg-gradient-to-br from-green-600 to-emerald-700 relative overflow-hidden">
      {/* Background accents */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -right-24 w-72 h-72 bg-white/5 rounded-full blur-2xl" />
        <div className="absolute bottom-0 left-1/4 w-64 h-64 bg-black/10 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-2xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-white/20 text-white text-xs font-bold px-4 py-2 rounded-full mb-6">
          <i className="ri-mail-send-line" />
          Alertas de Tasas — Gratis
        </div>

        <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-3">
          Recibe la mejor tasa USD/VES todos los días
        </h2>
        <p className="text-green-100 text-sm mb-8 leading-relaxed">
          Te avisamos cuál es la forma más barata de enviar dinero a Venezuela. Sin spam, sin costo.
        </p>

        {status === 'success' ? (
          <div className="bg-white/20 border border-white/30 rounded-2xl p-8 text-white">
            <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
              <i className="ri-check-line text-white text-2xl" />
            </div>
            <h3 className="text-lg font-bold mb-2">¡Te has suscrito!</h3>
            <p className="text-green-100 text-sm">
              Recibirás la mejor tasa de cambio para enviar dinero a Venezuela directamente en tu correo.
            </p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tucorreo@ejemplo.com"
              className="flex-1 bg-white/90 border-2 border-white/30 focus:border-white rounded-xl px-4 py-3.5 text-sm text-gray-900 outline-none transition-colors"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="bg-white text-green-700 hover:bg-green-50 font-bold px-6 py-3.5 rounded-xl text-sm transition-all cursor-pointer whitespace-nowrap disabled:opacity-60"
            >
              {status === 'loading' ? (
                <span className="flex items-center gap-2">
                  <i className="ri-loader-4-line animate-spin" />
                  Enviando...
                </span>
              ) : (
                'Recibir alertas'
              )}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="text-red-200 text-sm mt-3">{errorMsg}</p>
        )}

        <p className="text-green-200 text-xs mt-5">
          Sin spam. Solo tasas de cambio. Cancela cuando quieras.
        </p>

        <div className="flex items-center justify-center gap-6 mt-6 text-green-200">
          {[
            { icon: 'ri-lock-line', label: 'Datos seguros' },
            { icon: 'ri-spam-3-line', label: 'Sin spam' },
            { icon: 'ri-money-dollar-circle-line', label: '100% gratuito' },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-1.5 text-xs">
              <i className={item.icon} />
              {item.label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
